import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { I18NextModule } from 'angular-i18next';
import { AlertModule, ButtonModule, MbsPopupType, ModalModule } from 'mbs-ui-kit';

@Component({
  selector: 'mbs-price-information-modal',
  templateUrl: './price-information-modal.component.html',
  standalone: true,
  imports: [CommonModule, AlertModule, ButtonModule, ModalModule, I18NextModule]
})
export class PriceInformationModalComponent {
  protected readonly alertType = MbsPopupType;
}
